module.exports = __webpack_public_path__ + "static/media/Question_Icon.8c7fa0d9.svg";